module.exports = __webpack_public_path__ + "static/img/kabaoou.3471905e.png";